import { createGate } from "effector-react";
function FTLSmartCreateGate() {
    const gate = createGate({});
    return gate;
}
export default FTLSmartCreateGate;
//# sourceMappingURL=FTLSmartCreateGate.js.map